export const videoGridConfig = {
  aspectRatio: 1.77777778,
  maxRows: 5,
  breakpoint: {
    mobile: 480,
    tab: 768,
    desktop: 1280,
  },
};
